import { InvitationDisplayMode } from "../enums/Enum";
import Animator from "./Animator";

export default class PreChatAnimator extends Animator {
    constructor(configurations, dom) {
        super(configurations, dom)
    }

    animate(options) {
        // const me = this;
        // const position = me.configuration.preChat.preChatPosition;
        //me.slideDrop(options, me.configuration, position);
        // switch (me.configuration.preChat.preChatDisplayMode) {
        //     case InvitationDisplayMode.Appear:
        //         var pureElement = me.getPureElement(options.element);
        //         var ele = me.getElement(options.element, pureElement);
        //         ele.style.display = 'block';
        //         break;
        //     case InvitationDisplayMode.Slide:
        //         me.slide(options, me.configuration, position);
        //         break;
        //     case InvitationDisplayMode.SlideFromLeft:
        //         me.slideFromLeft(options, me.configuration, position);
        //         break;
        //     case InvitationDisplayMode.SlideFromRight:
        //         me.slideFromRight(options, me.configuration, position);
        //         break;
        //     default:
        //         me.slideDrop(options, me.configuration, position);
        //         break;
        // }
    }
}